// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DZ5d","content":"styles_content__PV4XO"};